import { createSlice } from "@reduxjs/toolkit";

const initialState = []

const cartSlice = createSlice({
    name:"carts",
    initialState,
    reducers:{
        // each cart contains product objects which have an id and quantity
        //a user can have multiple carts in same store or different stores
        addToCart:(state,action)=>{
            state.cart.products.push(action.payload)
        },
        removeFromCart:(state,action)=>{},
        changeItemQuantity:(state,action)=>{
            const foundProduct = state.cart.products.filter((item)=>item._id == action.payload._id)
            if(foundProduct){
                foundProduct.quantity = action.payload.quantity
            }
        }
    }
})


export const {addToCart,removeFromCart} = cartSlice.actions
export default cartSlice.reducer